import { Suspense } from 'react'
import { RouterProvider } from 'react-router'
import { router } from '@/routes'
import { Toaster } from '@/components/ui/sonner'
import { PageLoader } from '@/components/loading'

export const App = () => {
  return (
    <>
      <Suspense fallback={<PageLoader />}>
        <RouterProvider router={router} />
      </Suspense>
      <Toaster />
    </>
  )
}
